import React, { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import axios from "axios";
import Snackbar from "@mui/material/Snackbar";

const apiUrl = process.env.REACT_APP_API_URL;

export default function DevisDialog({ visible, onHide, leadData, onDevisGenerated }) {
  const [formule, setFormule] = useState("avec_alcool");
  const [remise, setRemise] = useState(0);
  const [generating, setGenerating] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [devisInfo, setDevisInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [nbPersonnes, setNbPersonnes] = useState(leadData?.nbpers || 0);
  const [nbBarmen, setNbBarmen] = useState(1);
  const [structure, setStructure] = useState("tuk_tuk");
  const [options, setOptions] = useState([]);

  // Prix
  const prixAvecAlcool = 20;
  const prixSansAlcool = 16;
  const prixUnitaire = formule === "avec_alcool" ? prixAvecAlcool : prixSansAlcool;
  const sousTotalPrestation = nbPersonnes * prixUnitaire;
  const sousTotalOptions = options.reduce((sum, opt) => sum + (opt.prix || 0), 0);
  const sousTotal = sousTotalPrestation + sousTotalOptions;
  const montantRemise = (sousTotal * remise) / 100;
  const total = sousTotal - montantRemise;

 


  useEffect(() => {
    if (leadData?.nbpers) setNbPersonnes(leadData.nbpers);
  }, [leadData]);

  useEffect(() => {
    if (visible && leadData?.idLead) checkExistingDevis();
  }, [visible, leadData]);

  const checkExistingDevis = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${apiUrl}/IHM/api/generer_devis.php?lead_id=${leadData.idLead}`);
      if (response.data.a_devis === 1) setDevisInfo(response.data);
      else setDevisInfo(null);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseSnackbar = () => setOpenSnackbar(false);

  const ajouterOption = () => {
    setOptions([...options, { titre: "", description: "", prix: 0 }]);
  };

  const supprimerOption = (index) => {
    const newOptions = [...options];
    newOptions.splice(index, 1);
    setOptions(newOptions);
  };

  const modifierOption = (index, champ, valeur) => {
    const newOptions = [...options];
    newOptions[index][champ] = valeur;
    setOptions(newOptions);
  };

  const handleGenererDevis = async () => {
    if (!leadData) return;
    setGenerating(true);
    try {
      const response = await axios.post(`${apiUrl}/IHM/api/generer_devis.php`, {
        lead_id: leadData.idLead,
        nom: leadData.nomPrenom,
        email: leadData.email,
        tel: leadData.tel,
        lieu: leadData.lieu,
        nb_personnes: nbPersonnes,
        nb_barmen: nbBarmen,
        formule: formule,
        remise: remise,
        structure: structure,
        options: options,
        adminMod: localStorage.getItem("us"),
      });
      
      if (response.data.success) {
        setDevisInfo({
          a_devis: 1,
          lien_devis: response.data.devis_url,
          lien_pdf: response.data.pdf_url,
          numero_devis: response.data.devis_number,
          montant_devis: response.data.montant
        });
        setSnackbarMessage("Devis généré avec succès !");
        setOpenSnackbar(true);
        if (onDevisGenerated) onDevisGenerated();
        setTimeout(() => {
          onHide();
          resetForm();
        }, 2000);
      } else {
        setSnackbarMessage(response.data.message || "Erreur");
        setOpenSnackbar(true);
      }
    } catch (error) {
      setSnackbarMessage("Erreur lors de la génération");
      setOpenSnackbar(true);
    } finally {
      setGenerating(false);
    }
  };

  const resetForm = () => {
    setFormule("avec_alcool");
    setRemise(0);
    setNbPersonnes(leadData?.nbpers || 0);
    setNbBarmen(1);
    setStructure("tuk_tuk");
    setOptions([]);
  };

  // Styles pour supprimer le ring bleu
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      .p-inputnumber:focus, .p-inputnumber input:focus,
      .p-inputtext:enabled:focus, .p-inputtext:focus {
        box-shadow: none !important;
        outline: none !important;
        border-color: #ced4da !important;
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  const header = (
    <div className="flex justify-content-between align-items-center w-full">
      <span className="font-semibold text-lg">
        {devisInfo?.a_devis ? "Devis existant" : "Générer un devis"}
      </span>
    </div>
  );

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        message={snackbarMessage}
        action={
          <IconButton
            size="small"
            color="inherit"
            onClick={handleCloseSnackbar}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      />

      <Dialog
        blockScroll
        visible={visible}
        header={header}
        className="custom-dialog"
        style={{ width: "45vw", maxWidth: "700px" }}
        modal
        onHide={() => {
          onHide();
          resetForm();
        }}
        breakpoints={{ "960px": "90vw", "640px": "95vw" }}
      >
        <div className="p-3">
          <div className="grid">
            <div className="col-12 md:col-6">
              <div className="p-2 px-0 surface-100 border-round-sm flex justify-content-between align-items-center">
                <span className="font-bold">Client :</span>
                <span>{leadData?.nomPrenom || "-"}</span>
              </div>
            </div>
            <div className="col-12 md:col-6">
              <div className="p-2 px-0 surface-100 border-round-sm flex justify-content-between align-items-center">
                <span className="font-bold">Téléphone :</span>
                <span>{leadData?.tel || "-"}</span>
              </div>
            </div>
            <div className="col-12">
              <div className="p-2 px-0 surface-100 border-round-sm flex justify-content-between align-items-center">
                <span className="font-bold">Email :</span>
                <span>{leadData?.email || "-"}</span>
              </div>
            </div>
          </div>

          <>
            {/* Nombre de personnes et barmans */}
            <div className="grid mt-2">
              <div className="col-12 md:col-6">
                <div className="p-2 px-0 surface-100 border-round-sm flex justify-content-between align-items-center">
                  <span className="font-bold">Nb personnes :</span>
                  <div className="flex align-items-center gap-2">
                    <input
                      value={nbPersonnes}
                      onChange={(e) => setNbPersonnes(parseInt(e.target.value) || 0)}
                      min={1}
                      max={1000}
                      showButtons={false}
                      style={{ width: "80px", height: "35px", padding: "8px", borderRadius: "5px", border: "1px solid #ced4da" }}
                    />
                    <span className="text-sm text-gray-500">
                      ( {leadData?.nbpers || 0})
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-12 md:col-6">
                <div className="p-2 px-0 surface-100 border-round-sm flex justify-content-between align-items-center">
                  <span className="font-bold">Nb barmans :</span>
                  <input
                    value={nbBarmen}
                    onChange={(e) => setNbBarmen(parseInt(e.target.value) || 1)}
                    min={1}
                    max={10}
                    showButtons={false}
                    style={{ width: "80px", height: "35px", padding: "8px", borderRadius: "5px", border: "1px solid #ced4da" }}                  />
                </div>
              </div>
            </div>

            {/* Structure */}
            <div className="grid mt-2">
              <div className="col-12">
                <div className="p-2 px-0 surface-100 border-round-sm flex justify-content-between align-items-center">
                  <span className="font-bold">Structure :</span>
                  <Select
                    value={structure}
                    onChange={(e) => setStructure(e.target.value)}
                    size="small"
                    sx={{ minWidth: 200 }}
                    MenuProps={{
                        container: document.body,
                        style: { zIndex: 9999 },
                      }}
                  >
                    <MenuItem value="tuk_tuk">Le Tuk-Tuk Bar</MenuItem>
                    <MenuItem value="elegance">Le Bar Élégance</MenuItem>
                    <MenuItem value="both">
                      Le Tuk-Tuk Bar & Le Bar Élégance
                    </MenuItem>
                  </Select>
                </div>
              </div>
            </div>

            {/* Formule et Remise */}
            <div className="grid mt-2">
              <div className="col-12 md:col-6">
                <div className="p-2 px-0 surface-100 border-round-sm flex justify-content-between align-items-center">
                  <span className="font-bold">Formule :</span>
                  <Select
                    value={formule}
                    onChange={(e) => setFormule(e.target.value)}
                    size="small"
                    sx={{ minWidth: 180 }}
                     MenuProps={{
                        container: document.body,
                        style: { zIndex: 9999 },
                      }}
                  >
                    <MenuItem value="avec_alcool">
                      Avec alcool - 20€/pers
                    </MenuItem>
                    <MenuItem value="sans_alcool">
                      Sans alcool - 16€/pers
                    </MenuItem>
                  </Select>
                </div>
              </div>
              <div className="col-12 md:col-6">
                <div className="p-2 px-0 surface-100 border-round-sm flex justify-content-between align-items-center">
                  <span className="font-bold">Remise (%) :</span>
                  <input
                    value={remise}
                    onChange={(e) => setRemise(parseFloat(e.target.value) || 0)}
                    min={0}
                    max={100}
                    showButtons={false}
                    style={{ width: "80px", height: "35px", padding: "8px", borderRadius: "5px", border: "1px solid #ced4da" }}                  />
                </div>
              </div>
            </div>

            {/* Options supplémentaires */}
            <div className="grid mt-2">
              <div className="col-12">
                <div className="p-2 px-0 border-round-sm flex justify-content-between align-items-center">
                  <span className="font-bold">Options :</span>
                  <Button
                    label="Ajouter une option"
                    icon="pi pi-plus"
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#094ed8";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "#2563eb";
                    }}
                    className="p-button-sm text-white"
                    style={{
                      background: "#2563eb",
                      border: "none",
                      padding: "0.75rem",
                      borderRadius: "5px",
                    }}
                    onClick={ajouterOption}
                  />
                </div>
              </div>
            </div>

            {options.map((option, index) => (
              <div key={index} className="grid mt-1">
                <div className="col-12 md:col-4">
                  <InputText
                    value={option.titre}
                    onChange={(e) =>
                      modifierOption(index, "titre", e.target.value)
                    }
                    placeholder="Titre"
                    className="w-full"
                    style={{ height: "35px" }}
                  />
                </div>
                <div className="col-12 md:col-5">
                  <InputText
                    value={option.description}
                    onChange={(e) =>
                      modifierOption(index, "description", e.target.value)
                    }
                    placeholder="Description"
                    className="w-full"
                    style={{ height: "35px" }}
                  />
                </div>
                <div className="col-12 md:col-2">
                  <input
                    value={option.prix}
                    onChange={(e) => modifierOption(index, "prix", parseFloat(e.target.value) || 0)}
                    placeholder="Prix"
                    min={0}
                    showButtons={false}
                    style={{ width: "100%", height: "35px", padding: "8px", borderRadius: "5px", border: "1px solid #ced4da" }}
                  />
                </div>
                <div className="col-12 md:col-1">
                  <Button
                    icon="pi pi-trash"
                    className="p-button-danger p-button-text p-button-sm"
                    onClick={() => supprimerOption(index)}
                  />
                </div>
              </div>
            ))}

            {/* Calcul du prix */}
            <div className="grid mt-3">
              <div className="col-12">
                <div
                  className="p-2 px-0 border-round-sm"
                  style={{ background: "#e5e7eb", borderRadius: "5px" }}
                >
                  <div className="flex justify-content-between py-1">
                    <span>
                      Prestation ({nbPersonnes} x {prixUnitaire}€)
                    </span>
                    <span>{sousTotalPrestation.toFixed(2)} €</span>
                  </div>
                  {options.map(
                    (opt, idx) =>
                      opt.prix > 0 && (
                        <div
                          key={idx}
                          className="flex justify-content-between py-1"
                        >
                          <span>{opt.titre || "Option"}</span>
                          <span>{opt.prix.toFixed(2)} €</span>
                        </div>
                      ),
                  )}
                  <div className="flex justify-content-between pt-2 border-top-1 font-bold">
                    <span>Sous-total</span>
                    <span>{sousTotal.toFixed(2)} €</span>
                  </div>
                  {remise > 0 && (
                    <div className="flex justify-content-between py-1 text-red-500">
                      <span>Remise ({remise}%)</span>
                      <span>- {montantRemise.toFixed(2)} €</span>
                    </div>
                  )}
                  <div className="flex justify-content-between pt-2 border-top-1 font-bold text-lg">
                    <span>Total TTC</span>
                    <span>{total.toFixed(2)} €</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Bouton générer */}
            <div className="grid mt-3">
              <div className="col-12">
                <Button
                  label={generating ? "Génération..." : "Générer le devis"}
                  icon={generating ? "pi pi-spin pi-spinner" : "pi pi-file-pdf"}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#094ed8";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "#2563eb";
                  }}
                  className="w-full text-white"
                  style={{
                    background: "#2563eb",
                    border: "none",
                    padding: "0.75rem",
                    borderRadius: "5px",
                  }}
                  onClick={handleGenererDevis}
                  disabled={generating || nbPersonnes === 0}
                />
              </div>
            </div>
          </>
        </div>
      </Dialog>
    </>
  );
}